export const USERTYPE_ADMIN = "admin";
export const USERTYPE_OFFICE = "office";
export const USERTYPE_WAREHOUSE = "warehouse";

export const ROUTE_ROLE_DRIVER = "driver";
export const ROUTE_ROLE_LOADER = "loader";
export const ROUTE_ROLE_CREW = "crew";
